export default __webpack_public_path__ + "static/world-map-c131023960b95a9858832d5a48e71189.jpg";